import moment from 'moment'
import general from './general-setup'
import routeConfig from '../routes/config'

/**
 * 正则检测
 */
export const regExp = {
  // isRealname: /^[A-z]{3,15}$|^[\u4E00-\u9FA5]{2,4}$/,
  isRealname: /^([\u4e00-\u9fa5]{2,4}|[\u4e00-\u9fa5·]{1,20}(?:·[\u4e00-\u9fa5]{1,20}){0,5})(?:,[\u4e00-\u9fa5]{2,4}|,[\u4e00-\u9fa5·]{1,20}(?:·[\u4e00-\u9fa5]{1,20}){0,5})*$|^[A-z]{3,15}$/,
  isIdNo: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  isCellPhone: /^\d{11}$/,
  isEmail: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  isNumber: /^[0-9]+$/,
  isLetterOrNumber: /^[0-9a-zA-Z]+$/,
  isTwoDecimal: /^\d+$|^\d+(\.\d{0,2})+$/,
  startOrEndSpace: /(^\s*)|(\s*$)/g,
  // eslint-disable-next-line no-useless-escape
  checkPwd: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[`~!@#$^*()-\./?,<>;:'{}|])[a-zA-Z0-9+`~!@#$^*()-\./?,<>;:'{}|]+$/,
  checkSting: /^[a-zA-Z0-9+`~!@#$^*()-\\./?,<>;:'{}|]+$/,
  isPwdUnable: /(Xbed)|(2015)|(2016)|(2017)|([%&_+=\\[\]"]+$)/
}


// 预处理请求参数
export const handleParams = (orign) => {
  let param = orign
  Object.keys(param).forEach((v) => {
    if (param[v] === '') {
      delete param[v]
    }
  })
  return param
}

/**
 * 阿里云接口请求参数组装
 * @param {*} origin 
 */
export const joinParams = (origin) => {
  let params = ''

  Object.keys(origin).forEach((key, i) => {

    params = `${params}${i !== 0 ? '&' : ''}${key}=${origin[key]}`
  })
  return params
}

export const yuan = (money, keepTwoDecimal = true, needString = false) => {
  if (!money || typeof money !== 'number') return 0
  let result = Math.round(money) / 100
  if (keepTwoDecimal) {
    let r_s = result.toString()
    let po_decimal = r_s.indexOf('.')

    if (po_decimal < 0) {
      po_decimal = r_s.length
      r_s += '.'
    }

    while (r_s.length <= po_decimal + 2) {
      r_s += '0'
    }

    return needString ? r_s : r_s * 1
  }

  return result
}

/**
 * 元转分
 * @param {+} money 元
 */
export const fen = (money) => {
  return roundNumber(money, 100)
}

/**
 * 获取数字的四舍五入整数
 * @param {+} num 原数字
 * @param {*} multiple 转换倍数
 */
export const roundNumber = (num, multiple = 1) => {
  if (!num || typeof num !== 'number') return 0

  return Math.round(num * multiple)
}

/**
 * 散客入住、续住中 退房日期 -> 可选日期规则： 
 * 获取当前房间从当日起3个月内的可以用日期，
 * 如3个月内有一天不可选，则从该天起往后的日期都变为不可选；
 * 如3个月内所有日期都可以选，则超过3个月往后的日期都不可选
 * @param {*} calendar 
 */
export const disableQuitedDate = (calendar) => {

  let keys = Object.keys(calendar)

  for (let i = 0; i < keys.length; i++) {

    let data = calendar[keys[i]]
    if (data.status_before_type_cast !== 1) return moment(keys[i]).startOf('day')
  }

  return general.disableDay.startOf('day')
}

/**
 * 订单去重
 * @param {*} oldList 
 */
export const removeRepeatOrders = (oldList) => {
  let list = []
  let ids = []
  let cancelId = 0
  oldList && oldList.forEach((item) => {

    let i = ids.indexOf(item.checkinId)
    if (item.stat === 1 && item.payStat === 1) {
      cancelId = item.checkinId
    }
    if (i < 0) {
      list.push(item)
      ids.push(item.checkinId)
    }
    else if (item.stat === 1) {
      const obj = list.find(el => el.checkinId === item.checkinId)
      if (obj.checkin === 2) return
      if ((item.checkin === 2 && obj.checkin !== 2) || (item.checkin === 3 && obj.checkin !== 3))
        list.splice(i, 1, item)
    }
  })

  return {
    list: list,
    cancelId: cancelId
  }
}

/**
 * 订单来源过滤
 * @param {*} oldList 
 * @param {*} sourceId 要获取的订单来源id
 */
export const filterOrderSourceList = (oldList, sourceId) => {

  let list = oldList.filter(source => {
    //为[渠道性质-酒店前台、状态-启用、是否代下单-是] 的订单来源
    //如果传入了sourceId，则不需要过滤前台现客类型
    if ((source.isShow === 1 && source.status === 1 && source.sourceType === 4) || sourceId) {
      //过滤前台渠道
      // switch(source.sourceType) {
      // case 1: 
      //   source.name = `${source.name} | 自有渠道`
      //   break
      // case 2:
      //   source.name = `${source.name} | OTA渠道`
      //   break
      // case 3:
      //   source.name = `${source.name} | 业主渠道`
      //   break
      // default:
      //   break
      // }

      if (source.sourceType === 4 && source.name.indexOf('|') > -1) {
        source.otherName = source.name.split('|')[0].replace(/\s/, '')
      }

      source.expression = JSON.parse(source.expression || '{}')
      source.priceRelationDetail = JSON.parse(source.priceRelationDetail || '{}')

      return sourceId ? sourceId === source.id : true
    }
    return false
  })
  return list
}

/**
 * 筛选房型下可订房间 并 计算房间价格
 * @param {+} roomTypes 远期房态
 */
export const filterCanOrderRooms = (roomTypes = []) => {

  let list = roomTypes.filter(item => {
    //计算房型日历价格
    // let tPrice = 0
    // for (const key in item.calendar) {
    //   let t = item.calendar[key]
    //   tPrice += t.price
    // }
    // item.room_type_price = tPrice

    //信息房在起始结束日期之间的房价之和
    item.room_type_price = item.period_price
    let rooms = []
    if (item.no_info_room_price_date) {
      item.errMsg = '入住日期内，房间未设置价格'
    }
    else {
      rooms = item.rooms.filter(r => {
        let canOrder = true //是否可订

        r.price = item.period_price
        if (r.used_date) {
          //房间最近预订状态：1：可预订、2：已预订、3：维修、4：停用，若空，但used_date存在且日期价格为空则房价未设置
          //过滤非正常房间/停售房间is_presale=2
          canOrder = false
          switch (r.used_date_stat) {
            case 2:
              item.errMsg = '入住日期内，房间已被预订!'
              break
            case 3:
            case 4:
              item.errMsg = '入住日期内，房间有维修/停用!'
              break
            default:
              break
          }
        }
        if (r.is_presale === 2) {
          //过滤非正常房间/停售房间is_presale=2
          canOrder = false
          item.errMsg = '入住日期内，房间已停售'
        }
        if (r.flag !== 1) {
          //房间状态：1上架 2删除 3下架 4筹建中 5售前展示
          canOrder = false
          item.errMsg = '入住日期内，房间未上架'
        }

        return canOrder


        // let price = 0
        // let canOrder = true //是否可订
        // //计算房间日历价格
        // for (const key in r.calendar) {
        //   const info = r.calendar[key]
        //   if (info.stat !== 1 || r.flag !== 1 || r.is_presale === 2) {
        //     //过滤非正常房间/停售房间is_presale=2
        //     canOrder = false
        //     switch (info.stat) {
        //     case 2:
        //       item.errMsg = '入住日期内，房间已被预订!'
        //       break
        //     default:
        //       item.errMsg = info.stat ? '入住日期内，房间有维修/停用!' : '入住日期内，房间未设置价格'
        //       break
        //     }
        //     if (r.is_presale === 2) {
        //       item.errMsg = '入住日期内，房间已停售'
        //     }
        //     break
        //   }
        //   price += info.price
        // }
        // r.price = price
        // return canOrder
      })
    }

    item.rooms = rooms

    return true
  })
  return list || []
}

export const disableDateBeforeToday = (date) => {
  return date && date < sellDate()
}

/**
 * 判断是否是凌晨 0-6点
 */
export const isZeroToSixs = () => {
  // let hours = moment().hours()
  // let zeroTsix = moment().isAfter(moment().format('YYYY-MM-DD 00:00:00'), 'hour') && moment().isBefore(moment().format('YYYY-MM-DD 06:00:00'), 'hour')
  // return zeroTsix || hours < 1

  //凌晨 0 - 6点之间 21600000毫秒
  let nowDay = moment().valueOf()
  let today = moment().startOf('day').valueOf()
  let zeroTsix = nowDay < (today + 21600000)

  return zeroTsix
}

export const sellDate = () => {
  const subtract_num = isZeroToSixs() ? 1 : 0
  return moment().subtract(subtract_num, 'day').startOf('day')
}

/**
* 获取未入住的入住人id
*/
export const getCheckinerInfoIds = (checkiner) => {

  let infoIds = []
  checkiner && checkiner.map(item => {
    if (item.checkin === 1 && item.type !== -1) {
      infoIds.push(item.infoId)
    }
    return item.infoId
  })

  return infoIds.join(',')
}

/**
 * 是否线上验证判断， 门店楼宇中有一个是线上验证则统一 认为是线上验证
 */
export const isOnLineVerify = (hotelInfo) => {

  if (hotelInfo.buildings) {
    for (let i = 0; i < hotelInfo.buildings.length; i++) {
      let item = hotelInfo.buildings[i]
      if (item.verify_type === 0) {
        return true
      }
    }
    return false
  }

  return true
}

/**
 * 对时间进行 整点 或 半点 校正
 * 获取当前时间最近的时刻节点 30分 或 下一个整点
 */
export const latestTimeFromTime = (time) => {
  let now = moment(!time ? moment().format('YYYY-MM-DD HH:mm:00') : moment(time).format('YYYY-MM-DD HH:mm:00'))
  let latestBit = moment(now.format('YYYY-MM-DD HH:30:00'))
  let latestHour = moment(moment(now).add(1, 'hours').format('YYYY-MM-DD HH:00:00'))
  let nowHour = moment(now.format('YYYY-MM-DD HH:00:00'))

  let nowMinutes = now.minute()
  let nowHourMinutes = nowHour.minute()
  let latestMinutes = latestBit.minute()

  if (nowMinutes === latestMinutes || nowMinutes === nowHourMinutes) {
    //当前时间为整点或半点， 直接返回
    return now
  }

  if (nowMinutes < latestMinutes) {
    //大于整点小于半点， 使用半点时间
    return latestBit
  }

  return latestHour
}

/**
 * 判断时间是否大于设置的最大时长, 返回状态 1: 正常;  0: 大于最大小时长;  -1: 结束时间小于开始时间
 * start 开始时间
 * end 结束时间
 * maxHour 最大时长
 */
export const isTimeRightForHourRoom = (start, end, maxHour) => {
  let s = moment(start).add(maxHour, 'hours')
  let e = moment(end)

  if (e.isAfter(s, 'minutes')) {
    return 0
  }
  else if (e.isBefore(start)) {
    return -1
  }

  return 1
}

/**
 * 获取所有权限，去除树形结构
 * @param {*} list 权限数据
 * @param {*} returnObj 是否返回obj true 返回obj  , false 返回数组
 */
export const getAllRules = (list, returnObj = false) => {
  let rules = []
  let obj = {}

  for (let i = 0; i < list.length; i++) {
    const item = list[i]

    returnObj ?
      obj[item.action] = { ...item, powerList: null }
      :
      rules.push(item)

    if (item.powerList) {
      let childs = getAllRules(item.powerList, returnObj)

      returnObj ?
        obj = { ...obj, ...childs }
        :
        rules = rules.concat(childs)
    }
  }

  return returnObj ? obj : rules
}

/**
 * 存储权限到本地
 * @param {*} list 权限列表 
 */
export const saveRules = (list) => {
  let rules = getAllRules(list, true)

  const { menus } = routeConfig

  for (let i = 0; i < menus.length; i++) {
    const item = menus[i]
    if (rules[item.action]) {
      window.localStorage.setItem('XMSHOMEPAGE', item.key)
      break
    }
  }

  window.localStorage.setItem('XMSRULES', JSON.stringify(rules))
  window.localStorage.setItem('XMSRULESLIST', JSON.stringify(list))
}

/**
 * 根据action, 判断是否有权限 action为''，表示没有权限限制
 * 没有权限记录则去登录页
 */
export const hasRule = (action) => {
  let rules = JSON.parse(window.localStorage.getItem('XMSRULES'))
  if (!rules) {
    window.location.href = `${window.location.protocol}//${window.location.host}/login`
    return false
  }
  if (rules[action] || action === '')
    return true
  else
    return false
}

/**
 * 获取权限树
 */
export const getRules = () => {
  return JSON.parse(window.localStorage.getItem('XMSRULESLIST'))
}

/**
 * 获取首页重定向路径
 * 不同对权限可能对应不同对首页
 */
export const getRedirectPath = () => {
  return window.localStorage.getItem('XMSHOMEPAGE') || '/login'
}

/**
 * 移除所有localStorage
 */
export const removeAllLocalStorages = () => {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('oms-token')
  window.localStorage.removeItem('userInfo')
  window.localStorage.removeItem('XMSHOMEPAGE')
  window.localStorage.removeItem('XMSRULES')
  window.localStorage.removeItem('XMSRULESLIST')
  window.localStorage.removeItem('hotels')
  window.localStorage.removeItem('hotelInfo')
}


// WEBPACK FOOTER //
// ./src/utils/index.js